module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-dots-4-d1296c38939b386dbe41194dcce1a6de.svg";